import { hasExactKeys, isBoundedProtocolString, isRecord } from './protocol-validation';
import type { PaypercutBillingDetails } from '../types/elements';

export const ELEMENTS_PAYMENT_CONFIRMATION_PROTOCOL_VERSION = 1 as const;
const MAX_PROTOCOL_ID_LENGTH = 128;

export type ElementsPaymentConfirmationUseSDKAction = {
  paymentIntentId: string;
  paymentMethodId: string;
  attemptId: string;
  vault: 'bt';
  instrument: { type: 'token' | 'token_intent'; id: string };
  actionPhase: 'provider_recovery';
};

export type ElementsPaymentConfirmationStart = {
  type: 'start';
  actionId: string;
  payload: {
    protocolVersion: typeof ELEMENTS_PAYMENT_CONFIRMATION_PROTOCOL_VERSION;
    publishableKey: string;
    account?: string;
    apiUrl: string;
    sdkVersion: string;
    deadlineAt: number;
    checkoutSession: {
      id: string;
      amount: number;
      currency: string;
      mode: 'payment' | 'setup' | 'subscription';
    };
    action: ElementsPaymentConfirmationUseSDKAction;
    billingDetails?: Pick<PaypercutBillingDetails, 'name' | 'email'>;
  };
};

export type ElementsPaymentConfirmationMessage =
  | { type: 'ready'; actionId: string }
  | ElementsPaymentConfirmationStart
  | {
      type: 'complete';
      actionId: string;
      payload: { threeDSSessionId: string };
    };

export const isElementsPaymentConfirmationMessage = (
  value: unknown,
): value is ElementsPaymentConfirmationMessage => {
  if (!isRecord(value) || !isBoundedProtocolString(value.actionId, MAX_PROTOCOL_ID_LENGTH)) {
    return false;
  }
  if (value.type === 'ready') return hasExactKeys(value, ['type', 'actionId']);
  if (value.type !== 'complete') return false;
  return (
    hasExactKeys(value, ['type', 'actionId', 'payload']) &&
    isRecord(value.payload) &&
    hasExactKeys(value.payload, ['threeDSSessionId']) &&
    isBoundedProtocolString(value.payload.threeDSSessionId, MAX_PROTOCOL_ID_LENGTH)
  );
};
